const shapes = document.querySelector(".shapes");
const delay = setTimeout(()=>{
    shapes.classList.add("reveal-shapes");
}, 0);

//# sourceMappingURL=index.dec18b21.js.map
